import React from 'react';
import {Dropdown} from '../varios/Dropdown';

export const HeadGraficas = (props) => {
	const {nombreGrafica, cambiarNombreGrafica} = props;
	/* a object with the options for the dropdown */
	const options = [
		{value: 'line', label: 'Empresa 1'},
		{value: 'pie', label: 'Empresa 2'},
		{value: 'bar', label: 'Empresa 3'},
	];
	return (
		<div className='headContentUsuarios'>
			<div className='superiorHeadContentUsuarios'>
				<div>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='40'
						height='40'
						fill='currentColor'
						className='bi bi-pie-chart-fill'
						viewBox='0 0 16 16'
					>
						<path d='M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z' />
					</svg>
				</div>
				<div className='centrador titleHeadHistorialFacturas'>Graficas</div>
			</div>
			<div className='separador'></div>
			<div className='inferiorHeadContentUsuarios'>
				<div className='izqheadContentUsuarios centrador'>
					<div className='dropdownGraficas centrador input'>
						<Dropdown
							options={options}
							value={nombreGrafica}
							onChange={cambiarNombreGrafica}
							placeholder='Select an option'
						/>
					</div>
				</div>
				<div className='derheadContentUsuarios centrador'>
					<div className='button'>
						<b>Generar graficas</b>
					</div>
				</div>
			</div>
		</div>
	);
};
